/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'paper-clip': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M19.874 12a.75.75 0 00-1.28-.531l-7.692 7.683a3.75 3.75 0 11-5.3-5.307l9.306-9.436a2.25 2.25 0 113.179 3.185L8.78 17.03a.75.75 0 11-1.056-1.065l7.81-7.94a.75.75 0 10-1.07-1.051L6.66 14.909a2.25 2.25 0 103.186 3.178l9.306-9.436a3.75 3.75 0 10-5.307-5.3l-9.306 9.437a5.25 5.25 0 007.424 7.425l7.692-7.683a.75.75 0 00.22-.53z" _fill="#EF7812"/>'
  }
})
